var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-preview-area",class:{ disabled: _vm.disabled }},[_c('div',{staticClass:"input-group"},[_c('Hex',{attrs:{"red":_vm.red,"green":_vm.green,"blue":_vm.blue,"updateColor":_vm.updateColor}}),_c('RGB',{attrs:{"red":_vm.red,"green":_vm.green,"blue":_vm.blue,"alpha":_vm.alpha,"updateColor":_vm.updateColor}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }